const END_POINT = "https://www.auditapp.one/content/";

export const fetchData = async (slug: string) => {
  let res = await fetch(END_POINT + slug);
  let data = res.json();
  return data;
};
